import { useEffect, useRef, useState } from "react";

const SESSION_KEY = "raijada_new_video_popup_shown";

const isAnyDialogOpen = () => !!document.querySelector('[role="dialog"][data-state="open"]');

export const useNewVideoPopup = () => {
  const [open, setOpen] = useState(false);
  const shownRef = useRef(false);
  const retryRef = useRef(null);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) {
      shownRef.current = true;
      return;
    }

    const attempt = () => {
      if (shownRef.current) return;
      if (isAnyDialogOpen()) {
        retryRef.current = setTimeout(attempt, 3000);
        return;
      }
      shownRef.current = true;
      sessionStorage.setItem(SESSION_KEY, "1");
      setOpen(true);
    };

    const timer = setTimeout(attempt, 5000);
    return () => {
      clearTimeout(timer);
      clearTimeout(retryRef.current);
    };
  }, []);

  return { open, setOpen };
};
